import styled from "styled-components";
import { bp } from "theme";

export const Container = styled.div`
	background: white;
	border-radius: 12px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 16px;
	max-width: 1040px;
	margin: 0 auto;
	${bp.md} {
		padding: 16px 0;
	}
`;

export const Heading = styled.div`
	color: #190a28;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	${bp.md} {
		font-weight: 700;
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 16px;
	}
`;

export const Description = styled.div`
	color: #8c8594;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	${bp.md} {
		max-width: initial;
		font-size: 16px;
		line-height: 24px;
	}
`;

export const SubHeading = styled.div`
	color: #190a28;
	font-weight: 600;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
`;

export const ImageContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	width: 216px;
	height: 144px;
`;

export const TrendingJobs = styled.div`
	.MuiChip-outlinedPrimary {
		color: grey;
		border: 1px solid grey;
	}
`;
